"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHostSlice = void 0;

var tslib_1 = require("tslib");

var core_1 = require("@slicesjs/core");

var react_1 = require("react");

var SlicesProvider_1 = require("../components/SlicesProvider");
/**
 * Load the remote slice module and expose `mount` function
 */


var useHostSlice = function useHostSlice(_a) {
  var packageName = _a.packageName,
      url = _a.url,
      disableCdnCache = _a.disableCdnCache,
      _b = _a.UNSAFE_customScriptInitializer,
      scriptInitializer = _b === void 0 ? core_1.loadWithWebpack : _b;
  var module = './Index';

  var _c = tslib_1.__read((0, react_1.useState)(), 2),
      error = _c[0],
      setError = _c[1];

  var _d = tslib_1.__read((0, react_1.useState)(), 2),
      sliceUrl = _d[0],
      setSliceUrl = _d[1];

  var _e = tslib_1.__read((0, react_1.useState)(undefined), 2),
      localConfig = _e[0],
      setLocalConfig = _e[1];

  var _f = (0, SlicesProvider_1.useSlicesContext)(),
      contextOrigin = _f.origin,
      errorComponent = _f.errorComponent,
      loadingComponent = _f.loadingComponent;

  var _g = (0, react_1.useMemo)(function () {
    var _a;

    return getSliceInfo(packageName, (_a = localConfig === null || localConfig === void 0 ? void 0 : localConfig.url) !== null && _a !== void 0 ? _a : url, contextOrigin);
  }, [packageName, localConfig, contextOrigin, url]),
      sliceKey = _g.sliceKey,
      formattedUrl = _g.formattedUrl,
      sliceVersion = _g.sliceVersion;

  var sliceName = (0, core_1.getSliceName)(packageName);
  (0, react_1.useEffect)(function () {
    /**
     * It reads the local slice configuration from local storage if set by the extension
     * @returns A PartialURL object or undefined if not set.
     */
    var readLocalSlice = function readLocalSlice() {
      var _a;

      var localConfigString = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem("SLICE_LOCAL_".concat(sliceName));

      if (localConfigString) {
        console.info('📡 Slice version controller sent a slice change');
        return JSON.parse(localConfigString);
      }

      return undefined;
    };

    var storageListener = function storageListener() {
      setLocalConfig(readLocalSlice());
    };

    setLocalConfig(readLocalSlice());
    window === null || window === void 0 ? void 0 : window.addEventListener('storage', storageListener);
    return function () {
      window === null || window === void 0 ? void 0 : window.removeEventListener('storage', storageListener);
    };
  }, [sliceName]);
  (0, react_1.useEffect)(function () {
    (0, core_1.getSliceDetails)({
      packageName: packageName,
      url: formattedUrl,
      disableCdnCache: disableCdnCache
    }).then(function (_a) {
      var sliceUrl = _a.sliceUrl;
      setSliceUrl(sliceUrl);
    });
  }, [packageName, formattedUrl, disableCdnCache]); // we get the mount function from the cache in case this slice was already mounted
  // this way we don't have to wait for the async importWithWebpack to resolve
  // disable caching if using a local config

  var cachedMount = !localConfig ? (0, core_1.getMountCacheSync)(sliceKey) : false;

  var _h = tslib_1.__read((0, react_1.useState)(), 2),
      _j = _h[0],
      mount = _j === void 0 ? cachedMount : _j,
      setMount = _h[1];

  (0, react_1.useEffect)(function () {
    if (!cachedMount && sliceUrl) {
      (0, core_1.loadScript)(sliceUrl).then(function () {
        return scriptInitializer(sliceName, module);
      }).then(function (exports) {
        if (exports === null || exports === void 0 ? void 0 : exports.mount) {
          /**
           * We need to use the function argument on the state hook to
           * prevent the `mount` function from being
           * executed.
           **/
          setMount(function () {
            return exports.mount;
          });
          (0, core_1.setMountCacheSync)(sliceKey, exports.mount);
        } else {
          setError(new Error('No "mount" function found on remote module.'));
        }
      }).catch(setError);
    }

    return function () {
      setError(undefined);
      setMount(undefined);
    };
    /** Do not include mount to avoid infinite loop */
  }, [cachedMount, scriptInitializer, sliceUrl, sliceKey, sliceName]);
  return {
    mount: mount,
    error: error,
    sliceName: sliceName,
    sliceVersion: sliceVersion,
    sliceUrl: sliceUrl,
    errorComponent: errorComponent,
    loadingComponent: loadingComponent,
    setSliceUrl: setSliceUrl
  };
};

exports.useHostSlice = useHostSlice;

function getSliceInfo(packageName, url, contextOrigin) {
  var _a;

  var sliceKey;
  var formattedUrl;
  var sliceVersion = 'latest';

  if (_typeof(url) === 'object') {
    var version = (_a = url.version) !== null && _a !== void 0 ? _a : sliceVersion;
    formattedUrl = tslib_1.__assign({
      origin: contextOrigin
    }, url);
    sliceKey = packageName + version;
    sliceVersion = version;
  } else if (typeof url === 'undefined') {
    formattedUrl = {
      origin: contextOrigin
    };
    sliceKey = packageName;
  } else {
    sliceKey = url;
    formattedUrl = url;
  }

  return {
    sliceKey: sliceKey,
    formattedUrl: formattedUrl,
    sliceVersion: sliceVersion
  };
}